import { useContext, useEffect, type ReactNode } from "react";
import { Dialog, DialogHeader, DialogTitle, ImperativeDialogContext } from "@repo/ui";
import type { View } from "../workflow-creation-context-provider";
import { useWorkflowCreationContext } from "../workflow-creation-context-provider";
import { ActionView } from "./views/action-view/action-view";
import { DefaultView } from "./views/default-view/default-view";
import { MetadataView } from "./views/metadata-view/metadata-view";
import { StatusView } from "./views/status-view/status-view";

type Props = {
  onClose?: () => void;
  customTitle?: string;
};

export const WorkflowsDialog = ({ onClose, customTitle }: Props) => {
  const {
    state: { currentView, isUpgradeMode },
  } = useWorkflowCreationContext();
  const dialogContext = useContext(ImperativeDialogContext);

  const viewMap: {
    [key in View]: { component: ReactNode; title: string; contentClassName?: string };
  } = {
    default: {
      component: <DefaultView onClose={onClose} />,
      title: customTitle || (isUpgradeMode ? "Edit Workflow Package" : "Create Workflow"),
    },
    fields: {
      component: <MetadataView />,
      title: "Metadata Fields",
    },
    statuses: {
      component: <StatusView />,
      title: "Item Status",
    },
    actions: {
      component: <ActionView />,
      title: "Actions",
      contentClassName: "max-w-4xl",
    },
  };

  useEffect(() => {
    const className = viewMap[currentView].contentClassName;
    if (className) {
      dialogContext?.updateCurrentDialog({ contentClassName: className });
    } else {
      dialogContext?.updateCurrentDialog({ contentClassName: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView]);

  return (
    <Dialog>
      <DialogHeader>
        <DialogTitle>{viewMap[currentView].title}</DialogTitle>
      </DialogHeader>
      <div>{viewMap[currentView].component}</div>
    </Dialog>
  );
};
